module.exports = __webpack_public_path__ + "static/img/brees-2015-top-image-thumb.c4a296b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-top-image-thumb.jpg
// module id = +PpU
// module chunks = 1